import { render, staticRenderFns } from "./Nuevo-cliente.vue?vue&type=template&id=51c1926c&scoped=true"
import script from "./Nuevo-cliente.vue?vue&type=script&lang=js"
export * from "./Nuevo-cliente.vue?vue&type=script&lang=js"
import style0 from "./Nuevo-cliente.vue?vue&type=style&index=0&id=51c1926c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c1926c",
  null
  
)

export default component.exports